<template>
  <div
    class="tooltip-block"
    :class="{
      'top': top,
      'bottom': bottom,
      'left': left,
      'right': right,
      'right-position': rightPosition
    }"
  >
    <div
      class="tooltip-block__content js-tooltip"
      :style="{width : `${width}px`}"
      :class="{
        'only-text': !title && !textLeft,
        'text-left': textLeft,
      }"
    >
      <UiText
        v-if="title"
        font="text-l"
        bold
        color="tooltip-text-color"
        class="tooltip-block__title"
      >
        <div v-html="title" />
      </UiText>
      <UiText
        v-if="text"
        font="body-caption"
        color="tooltip-text-color"
        class="tooltip-block__text"
      >
        <div v-html="text" />
      </UiText>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiTooltip',
  props: {
    title: { type: String },
    text: { type: String },
    top: { type: Boolean },
    bottom: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    rightPosition: { type: Boolean },
    textLeft: { type: Boolean },
    width: { type: [Number, String] },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
